/**
 * 增强版移除 aria-hidden 属性指令
 * 支持更多配置和功能
 */

const DEFAULT_OPTIONS = {
    selector: '.el-radio__original',
    delay: 0,
    log: process.env.NODE_ENV === 'development',
    recursive: true,
    attributes: ['aria-hidden'] // 可以配置要移除的属性数组
};

export default {
    name: 'remove-aria-hidden',

    bind(el, binding) {
        const options = parseOptions(binding);
        el._removeAriaHiddenOptions = options;

        // 延迟执行
        setTimeout(() => {
            executeRemoval(el, options);
        }, options.delay);
    },

    inserted(el) {
        const options = el._removeAriaHiddenOptions;
        if (options && options.retry) {
            // 插入后再次执行，确保动态内容被处理
            setTimeout(() => {
                executeRemoval(el, options);
            }, 100);
        }
    },

    componentUpdated(el) {
        const options = el._removeAriaHiddenOptions;
        if (options) {
            // 组件更新后重新执行
            setTimeout(() => {
                executeRemoval(el, options);
            }, options.delay);
        }
    },

    unbind(el) {
        // 清理存储的配置
        if (el._removeAriaHiddenOptions) {
            delete el._removeAriaHiddenOptions;
        }
    }
};

/**
 * 解析指令参数和修饰符
 */
function parseOptions(binding) {
    const options = { ...DEFAULT_OPTIONS };

    // 处理值：可以是字符串选择器，也可以是配置对象
    if (binding.value) {
        if (typeof binding.value === 'string') {
            options.selector = binding.value;
        } else if (typeof binding.value === 'object') {
            Object.assign(options, binding.value);
        }
    }

    // 处理修饰符
    if (binding.modifiers) {
        const modifiers = binding.modifiers;

        if (modifiers.radio) options.selector = '.el-radio__original';
        if (modifiers.checkbox) options.selector = '.el-checkbox__original';
        if (modifiers.input) options.selector = '.el-input__inner';
        if (modifiers.select) options.selector = '.el-select__input';
        if (modifiers.all) options.selector = '[aria-hidden]';
        if (modifiers.immediate) options.delay = 0;
        if (modifiers.retry) options.retry = true;
        if (modifiers.silent) options.log = false;
    }

    return options;
}

/**
 * 执行移除操作
 */
function executeRemoval(el, options) {
    try {
        let elements;

        if (options.recursive) {
            elements = el.querySelectorAll(options.selector);
        } else {
            elements = Array.from(el.children).filter(child =>
                child.matches(options.selector)
            );
        }

        if (elements.length === 0) {
            if (options.log) {
                console.warn(`[v-remove-aria-hidden] 未找到匹配 ${options.selector} 的元素`);
            }
            return;
        }

        const stats = {
            total: elements.length,
            removed: 0,
            failed: 0
        };

        elements.forEach(element => {
            options.attributes.forEach(attr => {
                if (element.hasAttribute(attr)) {
                    try {
                        element.removeAttribute(attr);
                        stats.removed++;

                        if (options.log) {
                            console.log(`[v-remove-aria-hidden] 移除 ${attr} 属性:`, element);
                        }
                    } catch (error) {
                        stats.failed++;
                        if (options.log) {
                            console.error(`[v-remove-aria-hidden] 移除 ${attr} 失败:`, error);
                        }
                    }
                }
            });
        });

        if (options.log) {
            console.log(`[v-remove-aria-hidden] 完成:`, stats);
        }

    } catch (error) {
        console.error(`[v-remove-aria-hidden] 执行失败:`, error);
    }
}